// membership modal
export const SET_MEMBERSHIP_MODAL_ID = 'SET_MEMBERSHIP_MODAL_ID'
export const SET_MEMBERSHIP_MODAL_IS_VISIBLE = 'SET_MEMBERSHIP_MODAL_IS_VISIBLE'

// membership form
export const MEMBERSHIP_FORM_REQUEST = 'MEMBERSHIP_FORM_REQUEST'
export const MEMBERSHIP_FORM_SUCCESS = 'MEMBERSHIP_FORM_SUCCESS'
export const MEMBERSHIP_FORM_ERROR = 'MEMBERSHIP_FORM_ERROR'
export const SET_USER_ID = 'SET_USER_ID'
export const SET_TEAM_ID = 'SET_TEAM_ID'
export const SET_ROLE = 'SET_ROLE'

// update membership role
export const UPDATE_MEMBERSHIP_REQUEST = 'UPDATE_MEMBERSHIP_REQUEST'
export const UPDATE_MEMBERSHIP_SUCCESS = 'UPDATE_MEMBERSHIP_SUCCESS'
export const UPDATE_MEMBERSHIP_ERROR = 'UPDATE_MEMBERSHIP_ERROR'

// Memberships
export const FETCH_MEMBERSHIPS_REQUEST = 'FETCH_MEMBERSHIPS_REQUEST'
export const FETCH_MEMBERSHIPS_SUCCESS = 'FETCH_MEMBERSHIPS_SUCCESS'
export const FETCH_MEMBERSHIPS_ERROR = 'FETCH_MEMBERSHIPS_ERROR'
export const SET_MEMBERSHIPS = 'SET_MEMBERSHIPS'
export const SET_META = 'SET_META'



// WEBPACK FOOTER //
// ./src/store/modules/memberships/types.js